export var searchBtn = {
  minHeight: '4.5rem',
  '& > i': {
    margin: 0
  }
};